<template>
  <div class="sidebar">
    <div class="transparent navigation navigation--v2">
      <app-logo class="mb-5 pl-4" />
      <v-list expand class="ps-sidebar" ref="scrollbar">
        <template v-for="item in visible_menu">
          <!-- submenu -->
          <template v-if="item.items">
            <v-list-group :ripple="false"
                          :key='item.title'
                          prepend-icon=''
                          no-action
                          append-icon=''
                          :group='item.group'
                          v-model='item.active'>
              <v-list-item slot='activator'
                           :ripple="false"
                           active-class="navigation-active"
                           class="my-2 menu-parent"
                           @click="delayedNavigateTo(item.items[0].to)">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon v-if='item.action'>
                      {{ item.action }}
                    </v-icon>
                    <span :class="[item.active ? 'font-weight-bold' : 'font-weight-medium', 'fs-14']">
                      {{ textTruncate(item.title) }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon small>{{ item.active ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                </v-list-item-action>
              </v-list-item>
              <template v-for='subItem in item.items.filter(i => !i.hidden)'>
                <v-list-item
                  v-if='!subItem.external'
                  :key='subItem.title'
                  :exact='subItem.exact'
                  active-class="navigation-active"
                  :to='subItem.to'
                  :ripple="false"
                >
                  <v-list-item-content>
                    <v-list-item-title class="fs-14">
                      {{ textTruncate(subItem.title) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-else
                  :key='subItem.title + "-ext"'
                  :exact='subItem.exact'
                  :ripple="false"
                  :href='subItem.to'
                  target='_blank'
                >
                  <v-list-item-content>
                    <v-list-item-title class="fs-14">
                      {{ textTruncate(subItem.title) }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon small>mdi-open-in-new</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
          <!-- single menu item -->
          <template v-else>
            <v-list-item :to="item.to" :key="item.path" :exact="item.exact" :ripple="false" class="my-2">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon v-if="item.action">{{ item.action }}</v-icon>
                  <span class="fs-14 font-weight-medium">
                    {{ textTruncate(item.title) }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="item.icon">
                <v-icon small>
                  {{ item.icon }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import AppLogo from '../Header/AppLogo.vue'
import { main_menu } from '@/helpers/menu'
import { textTruncate } from '@/helpers/helpers'

export default {
  name: 'Sidebar',
  data: () => ({
    main_menu,
    scrollbarSettings: {
      suppressScrollX: true,
      scrollXMarginOffset: 16
    }
  }),
  components: {
    // VuePerfectScrollbar,
    AppLogo,
  },
  computed: {
    ...mapGetters(['brand', 'theme', 'betaAccess']),
    // Items flagged `beta` are early-access and hidden unless the session's
    // profile.beta is set (core: am_beta_client_group). Filtered here rather than
    // in menu.js so the menu stays a plain declaration. Nothing is flagged today;
    // an entry that uses it must ALSO gate its routes in router/index.js — hiding
    // the link alone leaves the URL reachable. @since GG-993
    visible_menu () {
      return this.main_menu.filter(item => !item.beta || this.betaAccess)
    },
  },
  methods: {
    textTruncate (text) {
      return textTruncate(text, 32)
    },
    delayedNavigateTo (to) {
      // programmatically navigate with 50ms delay to prevent submenu collapse
      setTimeout(() => {
        this.$router.push(to)
      }, 50)
    }
  }
}
</script>
